import { fetchJobConnections } from '../actions/job';
import loadable from '@loadable/component';
import Loading from '../components/Loader';
import { getJobConnectionsById } from '../selectors/job';
import { fetchThread } from '../actions/messages';

const TradieView = loadable(() => import(/* webpackChunkName: "tradie" */ '../containers/Tradie'), {
  fallback: Loading
});

TradieView.needs = async (props, { getState, dispatch }) => {
  TradieView.preload();
  // We don't want to server render these parts. TODO better way to do this in routes?
  if (typeof SERVER !== 'undefined' && SERVER) return; //eslint-disable-line no-undef
  if (props.params.job) {
    await dispatch(fetchJobConnections(props.params.job));
    const connections = getJobConnectionsById(getState(), props.params.job);
    const connection = connections.find(c => c.id === Number(props.params.assignment));
    return await dispatch(fetchThread(connection.messageGroupId));
  }
  return await dispatch(fetchThread(props.params.group));
};
export default TradieView;
